import { useForm } from "@inertiajs/react";
import { Box, Container, Heading, Button, Text, HStack, VStack, Field, NativeSelect } from "@chakra-ui/react";
import { useAuth } from "@/hooks/useAuth";
import { Player } from "@/types";

interface Props {
  player: Player;
  code: string;
}

export default function New({ player, code }: Props) {
  const currentPlayer = useAuth().player!;

  const { data, setData, post, processing, errors } = useForm({
    player1_point: "",
    player2_point: "",
    code: code,
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    post("/my/1v1/games", {
      preserveState: true,
    });
  };

  const pointOptions = Array.from({ length: 13 }, (_, i) => i);

  return (
    <Container maxW="4xl" py={8}>
      <Box bg="white" p={8} rounded="lg" shadow="lg">
        <Heading size="xl" textAlign="center" mb={8}>
          1v1 試合結果の入力
        </Heading>

        <form onSubmit={handleSubmit}>
          <input type="hidden" name="code" value={code} />

          <HStack gap={8} align="start">
            <Box flex={1} bg="gray.50" p={6} rounded="md">
              <Heading size="md" textAlign="center" mb={4} color="gray.700">
                あなた
              </Heading>

              <VStack gap={4} align="start">
                <Box>
                  <Text fontSize="sm" fontWeight="medium" color="gray.600" mb={1}>
                    プレイヤー名
                  </Text>
                  <Text fontWeight="semibold">{currentPlayer.display_name}</Text>
                  <Text fontSize="xs" color="gray.500">
                    ID: {currentPlayer.player_id}
                  </Text>
                </Box>

                <Field.Root invalid={!!errors.player1_point}>
                  <Field.Label color="gray.600" fontSize="sm">
                    得点
                  </Field.Label>
                  <NativeSelect.Root>
                    <NativeSelect.Field value={data.player1_point} onChange={e => setData("player1_point", e.target.value)} placeholder="選択してください">
                      {pointOptions.map(point => (
                        <option key={point} value={point}>
                          {point}
                        </option>
                      ))}
                    </NativeSelect.Field>
                  </NativeSelect.Root>
                  <Field.ErrorText mt={1}>{errors.player1_point}</Field.ErrorText>
                </Field.Root>
              </VStack>
            </Box>

            <Box flex={1} bg="gray.50" p={6} rounded="md">
              <Heading size="md" textAlign="center" mb={4} color="gray.700">
                対戦相手
              </Heading>

              <VStack gap={4} align="start">
                <Box>
                  <Text fontSize="sm" fontWeight="medium" color="gray.600" mb={1}>
                    プレイヤー名
                  </Text>
                  <Text fontWeight="semibold">{player.display_name}</Text>
                  <Text fontSize="xs" color="gray.500">
                    ID: {player.player_id}
                  </Text>
                </Box>

                <Field.Root invalid={!!errors.player2_point}>
                  <Field.Label color="gray.600" fontSize="sm">
                    得点
                  </Field.Label>
                  <NativeSelect.Root>
                    <NativeSelect.Field value={data.player2_point} onChange={e => setData("player2_point", e.target.value)} placeholder="選択してください">
                      {pointOptions.map(point => (
                        <option key={point} value={point}>
                          {point}
                        </option>
                      ))}
                    </NativeSelect.Field>
                  </NativeSelect.Root>
                  <Field.ErrorText mt={1}>{errors.player2_point}</Field.ErrorText>
                </Field.Root>
              </VStack>
            </Box>
          </HStack>

          <Box textAlign="center" mt={8}>
            <Button type="submit" colorPalette="blue" size="lg" px={8} py={4} loading={processing}>
              試合結果を登録
            </Button>
          </Box>
        </form>
      </Box>
    </Container>
  );
}
